import { BaseCalculPrixAchat } from '../parametre-document/parametre-doc-api-normalize';

export function netPrixEntreeFromLine(item: {
    priceHT?: number | string | null;
    prix_achat?: number | string | null;
    remise?: number | string | null;
}): number {
    const pu = Number(item?.priceHT) || Number(item?.prix_achat) || 0;
    const remisePct = Number(item?.remise || 0);
    if (!Number.isFinite(remisePct) || remisePct <= 0) {
        return pu;
    }
    return pu * (1 - remisePct / 100);
}

export function isDocumentLinePrixEntreeModified(item: {
    priceHT?: number | string | null;
    prixUnitaireRef?: number | string | null;
    prix_achat?: number | string | null;
}): boolean {
    const current = Number(item.priceHT);
    const ref = Number(item.prixUnitaireRef ?? item.prix_achat);
    if (!Number.isFinite(current)) {
        return false;
    }
    if (!Number.isFinite(ref) || ref <= 0) {
        return true;
    }
    return Math.abs(current - ref) > 0.001;
}

export function resolvePrixEntreeUnitaireForCmup(
    item: Record<string, unknown>,
    product: unknown,
    baseCalculPrixAchat: BaseCalculPrixAchat
): number {
    if (isDocumentLinePrixEntreeModified(item as any)) {
        return netPrixEntreeFromLine(item as any);
    }
    if (baseCalculPrixAchat === 'produit' && product != null) {
        const p = (product as { data?: unknown })?.data ?? product;
        const row = p as Record<string, unknown>;
        const fromCard =
            Number(row?.achat_ht ?? row?.prix_unitaires ?? row?.prix_achat ?? row?.valeur_unitaire ?? 0) || 0;
        if (fromCard > 0) {
            return fromCard;
        }
    }
    return netPrixEntreeFromLine(item as any);
}

export function computeCmupWeightedAverage(params: {
    valeurPrecedent: number;
    quantiteStock: number;
    prixEntreeUnitaire: number;
    quantiteEntree: number;
}): number | null {
    const valeurPrecedent = Number(params.valeurPrecedent) || 0;
    const quantiteStock = Math.max(0, Number(params.quantiteStock) || 0);
    const prixEntreeUnitaire = Number(params.prixEntreeUnitaire) || 0;
    const quantiteEntree = Number(params.quantiteEntree) || 0;
    if (quantiteEntree <= 0) {
        return null;
    }
    const denom = quantiteStock + quantiteEntree;
    const valeurNouveau =
        denom > 0
            ? (valeurPrecedent * quantiteStock + prixEntreeUnitaire * quantiteEntree) / denom
            : prixEntreeUnitaire;
    const rounded = Number(Number(valeurNouveau).toFixed(3));
    if (!Number.isFinite(rounded) || rounded < 0) {
        return null;
    }
    return rounded;
}
